import { AriaDatapoint } from './AriaDatapoint';
import type { CustomData, DatapointOptions } from 'owa-analytics-types';
import type { MailboxInfo } from 'owa-client-types';

export default class UsageDatapoint extends AriaDatapoint {
    constructor(
        eventName: string,
        mailbox: MailboxInfo | undefined,
        customData?: CustomData,
        options?: DatapointOptions
    ) {
        const usageDatapointOptions: DatapointOptions = options ?? {};
        super(eventName, mailbox, customData, usageDatapointOptions);
    }
}
